import React from 'react';
import InView from 'react-intersection-observer';

interface ClassroomReadyKitProps {
  windowWidth: number;
}

export const ClassroomReadyKit: React.FC<ClassroomReadyKitProps> = ({
  windowWidth,
}) => {
  return (
    <section className="soccer-classroom-section">
      <div className="soccer-classroom-top-section">
        <div className="soccer-classroom-logo-title">
          <div className="soccer-classroom-logo-container">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120"
              height="108"
              viewBox="0 0 120 108"
              fill="none"
            >
              <path
                d="M112.938 53.9995C112.938 53.6028 112.923 53.214 112.907 52.8173H113.375C113.264 45.3907 111.51 38.0355 108.376 31.323L120 15.8191H97.3473C97.2838 15.7636 97.2282 15.7001 97.1727 15.6446C87.3261 6.11537 73.6551 0.743772 60 1.06908C59.6033 1.06908 59.2145 1.08495 58.8178 1.10082V0.640625C45.3769 0.838985 32.1582 6.41687 22.6448 15.835H0L11.7271 31.4737C8.52949 38.5274 6.87913 46.2714 7.06162 54.0154C7.06162 54.4121 7.07749 54.8009 7.09336 55.1976H6.63317C6.74425 62.6242 8.49775 69.9874 11.6318 76.6919L0 92.1799H22.6527C22.7083 92.2354 22.7718 92.2989 22.8273 92.3544C32.666 101.892 46.3449 107.271 59.9921 106.938C60.3888 106.938 60.7776 106.922 61.1743 106.906V107.366C74.6152 107.16 87.8339 101.59 97.3473 92.172H119.992L108.265 76.5332C111.463 69.4796 113.113 61.7356 112.93 53.9916M16.21 73.0897H12.6713L15.7736 71.9392C13.8852 66.6866 12.9252 61.0373 13.0997 55.1817H10.283C10.283 54.785 10.283 54.3962 10.2989 53.9995C10.3782 47.4774 11.8381 41.2331 14.3771 35.5441L12.6713 34.9093H36.4507L50.7643 53.9995L36.4507 73.0897H16.21ZM61.1822 100.9V103.717C60.7855 103.717 60.3967 103.717 60 103.701C48.9156 103.566 38.6247 99.4637 30.5157 92.7829L27.7308 94.4967L29.6509 92.0529L43.8773 73.0897H51.6927L58.1116 64.5364V43.4706L51.6927 34.9173H43.8773L29.9048 16.2873L27.8101 13.4626L30.968 15.5256C38.9183 9.97942 48.5665 6.80566 58.8257 7.10717V4.29045C59.2145 4.29045 59.6112 4.29045 60.0079 4.30632C71.1002 4.44121 81.3991 8.54329 89.5001 15.232L92.2058 13.4706L90.357 15.962L90.119 16.2793L90.0952 16.3111L76.1307 34.9252H68.3073L61.8884 43.4785V64.5443L68.3073 73.0976H76.1307L90.1031 91.7276C90.1031 91.7276 90.1031 91.7276 90.0952 91.7276L92.2692 94.5047L89.0082 92.5052C81.0579 98.0434 71.4176 101.209 61.1743 100.908M105.337 73.0897H83.5493L69.2356 53.9995L83.5493 34.9093H107.337L104.226 36.0598C106.115 41.3124 107.075 46.9617 106.9 52.8173H109.717C109.717 53.214 109.717 53.6028 109.701 53.9995C109.622 60.5216 108.17 66.766 105.623 72.447L107.329 73.0738H105.337V73.0818"
                fill="white"
              />
            </svg>
          </div>
          <h2 className="soccer-classroom-title">
            <span className="soccer-classroom-title-span">CLASSROOM </span>
            <span className="soccer-classroom-title-span">READY kit</span>
          </h2>
        </div>
        <p className="soccer-classroom-description">
          {windowWidth > 1200 ? (
            <>
              <span className="soccer-classroom-description-span">
                High-quality equipment paired with a practical
              </span>
              <span className="soccer-classroom-description-span">
                career-skills curriculum and full support - ready
              </span>
              <span className="soccer-classroom-description-span">
                for immediate classroom implementation.
              </span>
            </>
          ) : (
            <>
              <span className="soccer-classroom-description-span">
                High-quality equipment paired with{' '}
              </span>
              <span className="soccer-classroom-description-span">
                a practical career-skills curriculum{' '}
              </span>
              <span className="soccer-classroom-description-span">
                and support - ready for immediate{' '}
              </span>
              <span className="soccer-classroom-description-span">
                classroom implementation.{' '}
              </span>
            </>
          )}
        </p>
      </div>
      <div className="soccer-classroom-video-container">
        <InView triggerOnce>
          {({ ref, inView }) => (
            <video
              ref={ref}
              className="soccer-classroom-video"
              muted
              autoPlay
              loop={inView}
              playsInline
            >
              <source
                src="https://cdn.orqafpv.com/website/DroneSoccerSolutions.mp4"
                type="video/mp4"
              />
            </video>
          )}
        </InView>
      </div>
    </section>
  );
};
